import styled, { css } from "styled-components";
import buttonReset from "../../helpers/buttonReset";

const inputReset = css`
  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
  color: inherit;
  background: none;
  border: none;
  outline: none;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  display: block;
`;

export const Form = styled.form`
  width: 100%;
`;

export const Row = styled.div<{ marginBottom?: number; marginTop?: number }>`
  margin-bottom: ${({ theme, marginBottom = 0 }) =>
    `${theme.spacing.unit * marginBottom}px`};
  margin-top: ${({ theme, marginTop = 0 }) =>
    `${theme.spacing.unit * marginTop}px`};

  ${({ theme }) => css`
    @media screen and (min-width: ${theme.breakpoints.lg}px) {
      display: flex;
      justify-content: space-between;
    }
  `};
`;

export const Col = styled.div<{
  width?: number;
  marginLeft?: number;
  marginRight?: number;
}>`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing.unit * 2}px;

  ${({ theme, width = 100, marginLeft = 0, marginRight = 0 }) => css`
    @media screen and (min-width: ${theme.breakpoints.lg}px) {
      width: calc(
        ${width}% -
          ${theme.spacing.unit * marginLeft +
          theme.spacing.unit * marginRight}px
      );
      margin-left: ${theme.spacing.unit * marginLeft}px;
      margin-right: ${theme.spacing.unit * marginRight}px;
      margin-bottom: 0;
    }
  `};
`;

export const Label = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.palette.primary.default};
  margin-bottom: ${({ theme }) => theme.spacing.unit * 2}px;
`;

export const Button = styled.button`
  ${buttonReset};
  display: block;
  box-sizing: border-box;
  max-width: 150px;
  width: 100%;
  margin: 0 auto;
  margin-top: ${({ theme }) => theme.spacing.unit * 4}px;
  padding: ${({ theme }) => theme.spacing.unit * 2}px;
  background-color: ${({ theme }) => theme.palette.primary.default};
  color: ${({ theme }) => theme.palette.primary.contrast};
  text-transform: uppercase;
  font-weight: bold;
  border-radius: ${({ theme }) => theme.border.radius.medium}px;
`;

export const Input = styled.input`
  ${inputReset};
  width: 100%;
  background-color: ${({ theme }) => theme.palette.background.alternative};
  padding: ${({ theme }) => theme.spacing.unit * 2}px;
`;

export const Textarea = styled.textarea`
  ${inputReset};
  width: 100%;
  background-color: ${({ theme }) => theme.palette.background.alternative};
  padding: ${({ theme }) => theme.spacing.unit * 2}px;
  resize: vertical;
  min-height: 200px;
`;

export const FileInput = styled.input`
  ${inputReset};
  width: 100%;
  background-color: ${({ theme }) => theme.palette.background.default};
  padding: ${({ theme }) => theme.spacing.unit * 2}px;
  box-sizing: border-box;
  border: ${({ theme }) =>
    `${theme.border.solid.default} ${theme.palette.border.default}`};
  border-style: dashed;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.unit}px;

  &:last-child {
    margin-bottom: 0;
  }

  & > input {
    width: 40px;
  }

  & > label,
  & > input {
    display: block;
    flex-shrink: 0;
  }

  ${({ theme }) => css`
    @media screen and (min-width: ${theme.breakpoints.lg}px) {
      margin-right: ${({ theme }) => theme.spacing.unit * 2}px;
      margin-bottom: 0;

      &:last-child {
        margin-right: 0;
      }
    }
  `};
`;

export const Service = styled.div`
  margin: ${({ theme }) => theme.spacing.unit}px;

  & > input[type="number"] {
    ${inputReset};
    width: 100%;
    background-color: ${({ theme }) => theme.palette.background.alternative};
    padding: ${({ theme }) =>
      `${theme.spacing.unit}px ${theme.spacing.unit}px`};
    text-align: right;
    margin-top: ${({ theme }) => theme.spacing.unit}px;
  }

  & > input[type="number"]:disabled {
    opacity: 0.3;
  }
`;

export const Services = styled.div`
  margin: -${({ theme }) => theme.spacing.unit}px;

  ${({ theme }) => css`
    @media screen and (min-width: ${theme.breakpoints.lg}px) {
      display: flex;
      justify-content: flex-start;
    }
  `};
`;
